import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { IHoliday, ICreateHolidayRequest, IUpdateHolidayRequest } from '../model/holiday';

@Injectable({
  providedIn: 'root'
})
export class HolidayService {

  constructor(private http: HttpClient) { }

  searchHolidays(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IHoliday[]>>(
      `${environment.baseUrl}/v1/Holiday/searchHolidays`,
      request
    )
  }

  getHoliday(id: string){
    return this.http.get<string>(
      `${environment.baseUrl}/v1/Holiday/getHoliday/${id}`
    )
  }

  createHoliday(request: ICreateHolidayRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/Holiday/createHoliday`,
      request
    )
  }

  updateHoliday(request: IUpdateHolidayRequest){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/Holiday/updateHoliday/${request.id}`,
      request
    )
  }

  deleteHoliday(id: string){
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/Holiday/deleteHoliday/${id}`
    )
  }

}
